import { useState } from "react";
import { CityInput, TechPicker, lookupCompany } from "../components/founder/FounderLookups";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Footer from "../components/Footer";
import BrandMark from "../components/BrandMark";

export default function FounderInfo() {
  const nav = useNavigate();
  const [form, setForm] = useState({
    startup_name: "",
    legal_entity_name: "",
    inn: "",
    website: "",
    founder_name: "",
    email: "",
    telegram: "",
    phone: "",
    city: "",
    technologies: [],
  });
  const [innNote, setInnNote] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const setVal = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  const onInnBlur = async () => {
    setInnNote("");
    const c = await lookupCompany(form.inn);
    if (!c) return;
    setForm((f) => ({
      ...f,
      city: f.city.trim() ? f.city : c.city || "",
      legal_entity_name: f.legal_entity_name.trim() ? f.legal_entity_name : c.name || "",
    }));
    setInnNote(c.name ? `Найдено: ${c.name}${c.city ? `, ${c.city}` : ""}` : "");
  };

  const phoneOk = form.phone.replace(/\D/g, "").length >= 10;
  const valid =
    form.startup_name.trim() && form.website.trim() && form.founder_name.trim() &&
    /\S+@\S+\.\S+/.test(form.email) && form.telegram.trim().length >= 2 && phoneOk &&
    form.technologies.length > 0;

  const proceed = () => {
    sessionStorage.setItem("srd_founder", JSON.stringify(form));
    nav("/questionnaire");
  };

  return (
    <div className="min-h-screen flex flex-col">
      <div className="border-b border-black/10">
        <div className="max-w-screen-xl mx-auto px-8 py-5"><BrandMark /></div>
      </div>
      <main className="flex-1">
        <div className="max-w-screen-xl mx-auto px-8 py-16 md:py-24 grid md:grid-cols-12 gap-8">
          <div className="md:col-span-4">
            <div className="label-mono">ШАГ 02 / 03</div>
            <h1 className="mt-4 text-4xl md:text-5xl font-medium tracking-tight">О&nbsp;стартапе</h1>
            <p className="mt-4 text-foreground/70 leading-relaxed">
              Базовые контактные данные. Поля со звёздочкой обязательные.
            </p>
          </div>
          <div className="md:col-span-7 md:col-start-6 space-y-7">
            <Field label="Название стартапа *" testid="founder-name-input">
              <input className="field-input" value={form.startup_name} onChange={set("startup_name")} placeholder="Название проекта / бренд" />
            </Field>
            <Field label="Название юридического лица" testid="founder-legal-name-input">
              <input className="field-input" value={form.legal_entity_name} onChange={set("legal_entity_name")} placeholder='ООО «Ромашка» / ИП Иванов И.И.' />
            </Field>
            <Field label="ИНН" testid="founder-inn-input">
              <input className="field-input" value={form.inn} onChange={set("inn")} onBlur={onInnBlur} placeholder='10 цифр (юрлицо) или 12 (ИП)' inputMode="numeric" pattern="[0-9]*" />
              {innNote && <div className="mt-2 text-xs text-foreground/60" data-testid="founder-inn-note">{innNote}</div>}
            </Field>
            <Field label="Город" testid="founder-city-input">
              <CityInput value={form.city} onChange={setVal("city")} />
            </Field>
            <Field label="Сайт или лендинг *" testid="founder-website-input">
              <input className="field-input" value={form.website} onChange={set("website")} placeholder="https://example.com" />
            </Field>
            <Field label="Имя контактного лица *" testid="founder-contact-input">
              <input className="field-input" value={form.founder_name} onChange={set("founder_name")} placeholder="Иван Иванов" />
            </Field>
            <Field label="E-mail *" testid="founder-email-input">
              <input className="field-input" value={form.email} onChange={set("email")} placeholder="founder@startup.com" />
            </Field>
            <div className="grid md:grid-cols-2 gap-7">
              <Field label="Telegram *" testid="founder-telegram-input">
                <input className="field-input" value={form.telegram} onChange={set("telegram")} placeholder="@username" />
              </Field>
              <Field label="Телефон *" testid="founder-phone-input">
                <input className="field-input" value={form.phone} onChange={set("phone")} placeholder="+7 900 000-00-00" inputMode="tel" />
              </Field>
            </div>
            <div>
              <div className="label-mono mb-3">Ключевые технологии * <span className="normal-case text-foreground/50">— можно выбрать несколько</span></div>
              <TechPicker value={form.technologies} onChange={setVal("technologies")} />
            </div>
            <div className="pt-6 flex gap-4">
              <button className="btn-secondary" onClick={() => nav("/consent")}>Назад</button>
              <button data-testid="founder-continue-btn" className="btn-primary" disabled={!valid} onClick={proceed}>
                К опросу <ArrowRight size={16} />
              </button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

function Field({ label, testid, children }) {
  return (
    <label className="block">
      <div className="label-mono mb-2">{label}</div>
      <div data-testid={testid}>{children}</div>
    </label>
  );
}
